import "./index.scss"
import React, {useEffect, useState} from 'react';
import apply_icon from '../../assets/images/icons/apply-icon.png'
import Table from 'react-bootstrap/Table'
import {useSelector, useDispatch} from 'react-redux'
import {fetchAllApplications, clearApplications} from '../../actions'
import moment from 'moment'
import LoadingSpinner from "../../components/loadingSpiner";
import {FETCH_APPLICATION_STATUS_ID} from '../../store/loaders'
import {useHistory} from 'react-router-dom'
import ApplicationStatusModel from "../models/applicationStatusModel";
import FirmApplicationStatusModel from "../models/firmApplicationModel";
import PopupModel from "../../components/models/popupModel";
import pay_icon from '../../assets/images/icons/pay-icon.png'
import EmptyState from "../../components/EmptyState";
import empty_state_icon from '../../assets/images/empty-icon-1.png'






 const Application = ()=>{

    const dispatch = useDispatch()
    const history = useHistory()


    const apiResponse = useSelector(state=>{
        const {userApplications, loader,membership} = state
        const {applications} = userApplications
        const {isLoading} = loader[FETCH_APPLICATION_STATUS_ID] || {isLoading: false}
        const {application} = membership
        
        return {
            applications,
            isLoading,
            application
        }
    })


    var user = JSON.parse(localStorage.getItem('currentUser'))
    var actionLoader = apiResponse.isLoading

    const [showApplicationModel, setApplicationModel] = useState(false)
    const [showFirmModel, setFirmModel] = useState(false)
    const [modelData, setModelData] = useState('')
    const [showPopupModel, setPopupModel] = useState(false)
    const [firmData, setFirmData] = useState('')




    const handleApplicationModel = (data)=>{
        if(data?.status?.toLowerCase() === 'not submitted' || data?.status?.toLowerCase().includes('rejected')){
            if(data?.applicantType?.name === 'Firm Application'){
                history.push({
                    pathname: '/applicant/company/review-details',
                    state:{
                        application: data,
                        message:{
                            note: data?.latestComment || data?.note || data?.clientStatus,
                            date: moment(data?.createdAt).format('MMMM Do YYYY, h:mm:ss a'),
                            status:  data?.status
                        } 
                    }
                })
            }
            if(data?.applicantType?.name === 'Individual Application' || data?.applicantType === null){
                history.push({
                    pathname: '/applicant/review-details',
                    state:{
                        application: data,
                        message:{
                            note: data?.latestComment || data?.note || data?.clientStatus,
                            date: moment(data?.createdAt).format('MMMM Do YYYY, h:mm:ss a'),
                            status:  data?.status
                        }
                    }
                })
            }
            return
        }
        if(data && data?.applicantType?.name === 'Firm Application' || data?.itemType === "FIRM APPLICATION"){
            setFirmModel(true)
            setModelData('')
            setFirmData(data)
            return 
        }
        if(data && data?.applicantType?.name === 'Individual Application' || data?.itemType === "INDIVIDUAL APPLICATION"){
            setApplicationModel(true)
            setModelData(data)
            setFirmData('')
            return
        }
        setFirmModel(false)
        setApplicationModel(false)
    }


    const viewApplicationDetails = (data)=>{
        if(data.membershipClassId === null){
            return 
        }
        history.push({
            pathname: '/application/status',
            state: {
                application: data
            }
        })
    }

    useEffect(()=>{
        if(user.sub){
            dispatch(fetchAllApplications(user.sub))
        }
     },[])


    const handleNewClass = ()=>{
        var itemStatus = []
        itemStatus = apiResponse.applications && apiResponse.applications.filter(el=>{
            return el.status === 'not submitted'
        })
        if(itemStatus?.length > 0){
            setPopupModel(true)
        }
        else{
            history.push('/applicant')
            sessionStorage.setItem('application', true)
        }
        dispatch(clearApplications())
    }

    return (
        <div className="application_wrapper">
            <div className="toolbar">
                <div className="toolbar-title">
                    <h2>My Applications</h2>
                </div>
                <div className="apply-btn" onClick={handleNewClass}>
                    <img src={apply_icon} alt="file"/>
                    <span>{`${apiResponse.application ? 'Upgrade my' : 'Apply for a'} `} membership</span>
                </div>
            </div>
            <br/><br/>
            {actionLoader ? 
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'}}>
                    <LoadingSpinner
                        color={'#1D834F'}/>
                </div>
            :
        
            <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th>Applied on</th>
                            <th>Type</th>
                            <th>
                                Membership
                            </th>
                            <th>
                                Discipline
                            </th>
                            <th>
                                Education Level
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                      {apiResponse.applications?.length > 0 ? 
                        <>
                            {apiResponse.applications.map(value=>{
                                return(
                                    <tr>
                                        <td>{moment(value.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
                                        <td>{value.applicantType?.name}</td>
                                        <td>{value.membershipClassId?.name || 'firm'}</td>
                                        <td>{value.discipline?.name}</td>
                                        <td>{value.awardType?.name || '-'}</td>
                                        <td className={value.status}>{value.clientStatus || value.status}</td>
                                        <td>
                                            <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                backgroundColor : 'white', border : '1px solid #00AE51'}} onClick={()=>handleApplicationModel(value)}>
                                                <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                    <img style={{alignSelf : 'center'}}
                                                    src={require('../../assets/images/icons/icon_eye.svg').default}/>
                                                    <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>VIEW</span>
                                                </div>
                                            </button>
                                            { value.status === 'Pending payment' && <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                    backgroundColor : 'white', border : '1px solid #003D99', marginLeft:5}}
                                                    onClick={()=>history.push({
                                                        pathname: '/applicant/payment-details',
                                                        state: {
                                                            application: value,
                                                            isFirm:  value.membershipClassId.name === 'Firm' ? true : false
                                                        }
                                                    })}
                                                    >
                                                    <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                        <img style={{alignSelf : 'center'}}
                                                        src={pay_icon}/>
                                                        <span style={{fontSize : '10px', color : '#003D99', marginTop : '3px'}}>PAY</span>
                                                    </div>
                                                </button>}
                                        </td>
                                    </tr>
                                )
                            })}
                        </> 
                        : 
                        <React.Fragment>

                            <tr>
                            <td colSpan={7} style={{padding: '30px 0px'}}>
                                <EmptyState
                                    header="No applications available yet"
                                    content="Available applications will be displayed here"
                                    // noImage={true}
                                    img={empty_state_icon}
                                />
                            </td>
                        </tr>
                        </React.Fragment>
                        }
                    </tbody>
                </Table>
                }
        <ApplicationStatusModel 
            show={showApplicationModel} 
            hide={handleApplicationModel}
            data={modelData}
            />
        <FirmApplicationStatusModel
            show={showFirmModel} 
            hide={handleApplicationModel}
            data={firmData}
        />
         <PopupModel
            show={showPopupModel}
            hide={()=>setPopupModel(!showPopupModel)}
            content="There is still an application which is not submitted yet"
            btnText="OK"
            hideBtn={true}
            />
        </div>
    )
}

export default Application